import { emitOnClick, emitOnBlur, emitOnChange } from '@cred/react-analytics/hoc'
import withFieldChangeEvent from '@cred/react-analytics/hoc/withFieldChangeEvent'
import withLinkClickEvent from '@cred/react-analytics/hoc/withLinkClickEvent'
import navigateOnClick from '@cred/shared/hoc/navigateOnClick'
import emitGAOnClick from '@cred/shared/hoc/emitGAOnClick'
import { Link } from '@cred/react-link'
import { Input } from '../input'
import Dropdown from '../dropdown'
import MoneyInput from '../money-input'
import { AddressSearch } from '../address-search'
import { textInput, zipInput, selectCustom } from '@cred/react-form-field'

const linkWithAnalytics = navigateOnClick(withLinkClickEvent(emitOnClick(emitGAOnClick(Link)))),
	textInputWithAnalytics = withFieldChangeEvent(emitOnBlur(textInput)),
	zipInputWithAnalytics = withFieldChangeEvent(emitOnBlur(zipInput)),
	selectCustomWithAnalytics = emitOnChange(selectCustom),
	dropdownWithAnalytics = withFieldChangeEvent(Dropdown),
	addressSearchWithAnalytics = withFieldChangeEvent(AddressSearch),
	moneyInputWithAnalytics = withFieldChangeEvent(MoneyInput)

export {
	textInputWithAnalytics,
	zipInputWithAnalytics,
	selectCustomWithAnalytics,
	dropdownWithAnalytics as Dropdown,
	linkWithAnalytics as Link,
	Input,
	addressSearchWithAnalytics as AddressSearch,
	moneyInputWithAnalytics as MoneyInput,
}
